///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.template = abcsetup.template || {};
abcsetup.template.edit = abcsetup.template.edit || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.template.edit = {
    init: function() {
        CKEDITOR.create(document.getElementById('html'), CKEDITOR.config);
    },
}